import React from "react"
import { useTranslation } from "react-i18next"

import type { Site } from "@/models/site"
import { adminEntityFieldsMaxWidthSx } from "@/modules/admin/utils/admin-entity-fields-max-width-sx"
import { ReadonlyField } from "@/nzds/forms/readonly-field/readonly-field"
import { getDisplayValue } from "@/utils/value"

import { Stack } from "@mui/material"

interface SiteReadonlyFieldsProps {
  site: Site
}

export const SiteReadonlyFields: React.FC<SiteReadonlyFieldsProps> = ({
  site,
}) => {
  const { t } = useTranslation("common")

  return (
    <Stack sx={{ ...adminEntityFieldsMaxWidthSx, gap: 2 }}>
      <ReadonlyField
        label={t("fields.siteName.title")}
        value={getDisplayValue(site.name)}
      />
      <ReadonlyField
        label={t("editSite.idLabel")}
        value={getDisplayValue(site.id)}
      />
      <ReadonlyField
        label={t("fields.buildingType.title")}
        value={getDisplayValue(site.buildingType)}
      />
      <ReadonlyField
        label={t("fields.buildingArea.title")}
        value={getDisplayValue(site.sqFt)}
      />
      <ReadonlyField
        label={t("editSite.baCodeLabel")}
        value={getDisplayValue(site.baCode)}
      />
      <ReadonlyField
        label={t("editSite.addressLine1Label")}
        value={getDisplayValue(site.address?.address_line_1)}
      />
      <ReadonlyField
        label={t("editSite.addressLine2Label")}
        value={getDisplayValue(site.address?.address_line_2)}
      />
      <ReadonlyField
        label={t("editSite.cityLabel")}
        value={getDisplayValue(site.address?.city)}
      />
      <ReadonlyField
        label={t("editSite.stateLabel")}
        value={getDisplayValue(site.address?.state)}
      />
      <ReadonlyField
        label={t("editSite.postalCodeLabel")}
        value={getDisplayValue(site.address?.postal_code)}
      />
      <ReadonlyField
        label={t("editSite.countryLabel")}
        value={getDisplayValue(site.address?.country)}
      />
    </Stack>
  )
}
